import React, { useEffect, useState } from 'react';  
import firebase from './../../../firebase';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify'; 
import Logo from 'components/common/Logo'; 
import Background from 'components/common/Background'; 
import {Card,Row ,Form, Col, Button } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas' 
import {useFormatDate } from 'hooks';

import Flex from 'components/common/Flex';
import France from '../../../assets/img/country/france.png' 
import USA from '../../../assets/img/country/usa.png' 
import { API_URL } from 'constants'; 

const StateLieu = () => {
  const { id } = useParams(); 
  const [contract, setContrat] =  React.useState(null);
  const [l, setL] = React.useState(false);  
  const [formd, setFrom] = React.useState({}); 
  const [usersign, setUserSign] = React.useState(null);
  const [lsignbohouse, setLsignBohouse] =  useState(false)
  const [villas, setVilla] =  React.useState([]);
  const [actualCode, setActualCode] = React.useState(null);
  const [clients, setClients] = React.useState([]); 
  const [lsms, setLSMS] = React.useState(false);
  const [prep, setPrep] = React.useState(false); 
  const [stateLsms, setStateLsms] = useState(false);
  const [validated, setValidated] = React.useState(false);
  const [isFr, setIsFr] = React.useState(true);
    
  let sigCanvas = React.useRef()

  const getClient = () => {
    let c = null;
    clients.forEach(s => {
      if (s.id === contract?.client?.value){
        c = s;
      }
    })
    return c;
  }
 

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    const bURL64 =  sigCanvas.getTrimmedCanvas().toDataURL('image/png');
    const datasign = sigCanvas.toData();
    // console.log("sigCanvas",bURL64, datasign);
    if (form.checkValidity() === false) {
        return;
    }  

    if (l){
        return;
    }
    if (formd?.sms_code && formd?.sms_code === actualCode ){
      if (bURL64 && datasign.length > 0){
        setValidated(true); 
        setL(true);
        let sign = {
          bURL64: bURL64,
          datasign:JSON.stringify(datasign),
          date: new Date(),
          code : formd?.sms_code
        }
        firebase.firestore().collection('etatsdeslieux').doc(id).update({sign : sign}).then(()=>{
          // navigate('/booking/edit/'+doc.id);
          fetch(`${API_URL}sendEmailSignClientState`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({link: window?.location.href, }),
          }).then((res) => res.json())
            .then((data) => { 
              
            });

          alert("Merci, nous avons bien reçu votre signature d'état des lieux, nous vous contacterons si nécessaire. Thanks for sign, we will contact you if necessary.")
          window.location.reload();
          setLSMS(false);
          setActualCode(null)
           
            
          
      });
  
      }else{
        alert("Signer le document est obligatoire. Your sign is required")
      }
    }else{
      alert("Code sms invalide.")
    }


    


  }
  const handleChange = e => { 
    let d = {...formd};
    d[e.target.name] = e.target.value; 
    setFrom(d);  
  };
  

  const getUser = async (uid, cb) => { 
    await firebase.firestore()
      .collection("users")
      .doc(uid)
      .get()
      .then(async (docd) => {
        if (docd.exists){

          var user = docd.data();
          user.id = docd.id;
          if (user?.delete){
             cb(null)
          }else{ 
            cb(user);
          }
          
        }else{
          cb(null);
        }
      })
      .catch((error) => {
        console.log("error", error);
        cb(null);
      });
  };

  function isInternationalPhoneNumber(input) {
    // Regular expression for international phone numbers
    // This expression allows for numbers like:
    // +1234567890, +12 345 678 901, +123-4567-8901, +123.4567.8901
    var internationalPhoneNumberPattern = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    return internationalPhoneNumberPattern.test(input);
  }

  function makeid(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

  const sendSMS = () => {
    if (stateLsms){
      return;
    }
    firebase.firestore().collection('crm').doc(contract?.client?.value).get().then((doc)=> {
      console.log(doc.data()?.phone)
      let phone = doc.data()?.phone
      
      let p = "";
      if (Array.isArray(phone) && phone.length > 0){
         p = phone[0]; 
      }else{
        if (phone.includes(',')){
          let sr = [];
          let s = phone.split(',')
          s.forEach(e => {
            let sd = e.trim();
            if (sd && isInternationalPhoneNumber(sd)){
              sr.push(sd);
            }
          });
          if (sr.length > 0){
            p = sr[0];
          }
        }else{
          if (phone >= 10){
            p = phone.trim();
          }
        }
      }
      if (p && isInternationalPhoneNumber(p)){ 
        console.log('phone', phone)

        if (confirm("Je confirme avoir lu et j'accepte de recevoir mon sms de confirmation d'identité? I confirm that I have read and agree to receive my identity confirmation SMS?")){
          setStateLsms(true)
          const code = makeid(6);


          try {
            fetch(`${API_URL}sendSMS`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
                body: JSON.stringify({code:code,   phone :p }),
            }).then((res) => res.json())
                .then((data) => {
                  setStateLsms(false);
                  console.log("data", data); 
                  if (data.success && data.result.invalidReceivers.length === 0){ 
                    setLSMS(true);
                    setActualCode(code)
                  }   else{
                    if (data.result.invalidReceivers.length){
                      alert("Votre numero de téléphone est invalide, contactez nous. Your phone number is not valid, contact us.")
                    }else{
                      alert("une erreur s'est produite, veuillez réessayer");
                  
                    }
                  }
                })
            } catch (err) {
              console.log("err", err)
              setStateLsms(false);
              alert("une erreur s'est produite");
            }

        }
      }else{
        alert("Votre numero de téléphone est invalide, contactez nous. Your phone number is not valid, contact us.")
      }
    })
  }

  const pL = (dateDonnee) => { 
  // Date actuelle
    const dateActuelle = new Date(); // Date actuelle

    // Durée de 24 heures en millisecondes
    const vingtQuatreHeures = 24 * 60 * 60 * 1000; 

    // Différence entre la date actuelle et la date donnée en millisecondes
    const difference = dateActuelle.getTime() - dateDonnee.getTime();

    // Vérification si la différence est supérieure ou égale à 24 heures
    if (difference >= vingtQuatreHeures) {
        console.log("Il s'est écoulé plus de 24 heures depuis la date donnée.");
        return true;
    } else {
        console.log("Il ne s'est pas écoulé 24 heures depuis la date donnée.");
        return false
    }
  }

  const [equipements, setEquipements] = React.useState([]); 
  const [english, setEnglish] = React.useState([]); 
    
  function letEn (fr) {
    let r = fr; 
    english.forEach(e => {
      if (e.fr === fr){
        r = e.en;
      }
    })
    return r;
  }

  const getEn =  (text) => { 
    if (text){
      fetch(`${API_URL}traduction`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({text: text }),
      }) 
      .then((res) => res.json())
        .then((data) => {
            // console.log("data",text,  data); 
            let sl = english;
            sl.push({fr : text, en: data.en});
            setEnglish(sl); 
        }) 
    }else{
      console.log('text', text)
    }
    
  }

  const loadCt = () =>{
    if (l) return;

    setL(true); 

    firebase.firestore().collection('equiments').get().then((snap)=> {
      let s = [];
      snap.forEach((d) => {  
          let dr = d.data();
          dr.id = d.id
          s.push(dr)
      })

      s.forEach((e)=>{ 
        getEn(e.title);
      })
      setEquipements(s);  

  })


  // get list clients and format
  firebase.firestore().collection('etatsdeslieux').doc(id).get().then((snap)=> {
    let s = snap.data();
    s.id = snap.id
    setContrat(s);   
    getEn(s.comment) 
    // console.log('contract', contract) 
    s?.pieces?.forEach((p) => {
      getEn(p.title)
      getEn(p?.state?.label)
      getEn(p?.constat) 
    })
    if (s?.sign?.date){
      //  le client a signé
    }else{
      if (s?.type?.value === 'in'){
        // le client n'a pas encore signé es ce qu'il la vu
        if (s?.preDate === undefined || s?.preDate === null){
          firebase.firestore().collection('etatsdeslieux').doc(id).update({preDate: new Date()})
          }else{
            let sd = s?.preDate?.toDate()
            if (pL(sd) ){
              // on sign avec le contrat lié a l'éatat des lieux
              let sign = {
                bURL64: null,
                datasign:null,
                date: new Date(),
                code : "manuel"
              }
              firebase.firestore().collection('etatsdeslieux').doc(id).update({sign : sign}).then(()=>{
                alert("Signature automatique du client réalisé.")
                s.sign = sign;
                setContrat(s);  
              })
            }
          }
      }
      
      }
    setL(false); 
  }).catch((error) => {
    setL(false); 
    var errorMessage = error.message;
    toast.error(errorMessage);
  })
  }
 
  const loadVilla = () => { 
    firebase.firestore().collection('properties').get().then((snap)=> {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();  
        l.id = d.id;
        s.push(l)  
      })
      setVilla(s); 
    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  const getVilla = () => {
    let d = {};
    villas.forEach((s) => { 
      if (s.id === contract?.property?.value){
        d = s;
      }
    })
    // console.log('d', d);
    return d;
  }

  const getClients = () => {
    // get list clients and format
    firebase.firestore().collection('crm').get().then((snap)=> {
        let s = [];
        snap.forEach((d) => { 
            let ss = d.data()
            ss.id = d.id;
            s.push(ss)
        })
        setClients(s);
      }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
      })

}
 
  useEffect(() => {
    if (id){
      loadCt();
      loadVilla()
      getClients();
    }
  }, [])

 


  


  return (
    <>


<div style={{backgroundColor:'white', height:60, width: '100%', flexDirection:'row', display:'flex', justifyContent: 'end'}}>
     
    {!isFr ? (<Link onClick={() => {setIsFr(true)}} style={{ marginRight:30}}>
        <Flex alignItems="center">
          <img src={France} alt="..." />
          <p className="mb-0 ps-3 country text-700">
            Français
          </p>
        </Flex>
      </Link>) : (<Link onClick={() => {setIsFr(false)}} style={{ marginRight:30}}>
        <Flex alignItems="center">
          <img src={USA} alt="..." />
          <p className="mb-0 ps-3 country text-700">
            Anglais
          </p>
        </Flex>
      </Link>)}
      
    </div>






      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 40,
        paddingRight: 40
      }}>
        <Logo width={100}/>
        <div className="text-left"> 
        {usersign === null ? (
          <>
            <h5 className="mt-3 mb-0">{isFr ? 'Bonjour': 'Hi'} {!l && contract && contract?.client?.label}!</h5>
            <small>{isFr ? 'Voici votre état des lieux' : 'Inventory upon'} {contract?.type?.value === 'in' ? isFr ? "d'entrée": "arrival" : isFr ? 'de sortie' : 'exit'}.</small><br/> 
            {/* <small>Here is your rental contract {contract?.sign ? 'sign' :'to be signed'}.</small>  */}
          </>
        ) : (
          <>
          <h5 className="mt-3 mb-0">{isFr ? 'Bonjour': 'Hi'} {`${usersign?.lastName} ${usersign?.firstName}`}!</h5>

          </>
        )}
        
    </div>
      </div>
      {!l && contract && (<div class="container">
      {getVilla()?.gallery?.length > 0 && getVilla().gallery[0] != null && (
            <Card.Header
            className={'position-relative min-vh-40 mb-7'}
          >
            <Background image={getVilla().gallery[0]} className="rounded-3 rounded-bottom-0" />
             <div style={{position: 'relative',
  textAlign: 'center',
  color: 'white'}}>
                <div className='centered' style={{marginTop:100}}>
                    <h1 style={{color:'white '}}>{getVilla()?.type?.label} {getVilla().nameHouse}</h1>
                    {/* <h1 style={{color:'white'}}>PRIX SUR DEMANDE</h1> */}
                </div>
             </div>
          </Card.Header>
        )}
        <h1>{isFr ? 'Votre état des lieux' : 'Inventory upon'} {contract?.type?.value === 'in' ? isFr ? "d'entrée": "arrival" : isFr ? 'de sortie' : 'exit'}</h1>

        <p>
            {isFr ? 'Date d\'entrée' : 'Entry date'}: {useFormatDate( contract?.checkin?.toDate(), {
                   day:'numeric',
                 weekday: 'long',
                 year: 'numeric',
                 month: 'short', 
               })}<br/>{isFr ? 'Date de sortie' : 'Exit date'}:  {useFormatDate( contract?.checkout?.toDate(), {
                day:'numeric',
              weekday: 'long',
              year: 'numeric',
              month: 'short', 
            })}
        </p>
        <h3>{isFr ? "Adresse du bien" : "Property address"}</h3>
        <h4>{getVilla()?.type?.label} {getVilla()?.nameHouse}</h4>
        <p>{getVilla()?.adresse }
        <br/>{getVilla()?.zipcode } {getVilla()?.city }
        <br/>{getVilla()?.quartier }
        </p>
        <h3>{isFr ? "Locataire" : "Tenant"}</h3>
        <p>
          {contract?.client?.label}<br/>
          {getClient()?.adresse}<br/>
          {getClient()?.complement && <>{getClient()?.complement}<br/></>}
          {getClient()?.zipcode} {getClient()?.city}
        </p> 
        <h3>{isFr ? "Equipements" : "Equipment"}</h3>
        <p>{getVilla()?.equipments?.map((e, i)=>{
          return `${isFr ? e.label : letEn(e.label)}${i+1 < getVilla()?.equipments?.length  ? ', ': '.'}`;
        })}</p>


        {contract?.pieces?.map((p)=>{
          return <>
          <h3>{isFr ? p.title : letEn(p?.title)}</h3>
          <p>{isFr ? "État" : "Status"}: {isFr ? p?.state.label : letEn(p?.state.label)}<br/>
          {isFr ? "Constat" : "Report"}: {isFr ? p?.constat : letEn(p?.constat)}<br/>
          {isFr ? "Etage" : "Floor"}: {p?.level}</p>
          <div class="row mb-3">
          {
                  p?.photos && p?.photos?.map((f,i)=>{
                        return  <a class="col-md-4  themed-grid-col mt-4" target='_blank' href={f}>
                              <img src={f} style={{width:'100%', objectFit:'contain', backgroundColor:"lightgrey", height: 250}} />
                            </a>  
                       })  
                      }
                      </div>
          </>
        })}


        <h3>{isFr ? "Commentaire" : "Comment"}</h3>
        <p>{isFr ? contract?.comment : letEn(contract?.comment)}</p>

        <h5>{isFr ? "Fait le" : "Date"}</h5>
        <p><b>{isFr && "Date: "}</b>{useFormatDate(contract?._create_At?.toDate(), { day:'numeric',
                 weekday: 'long',
                 year: 'numeric',
                 month: 'short', })}<br/>
        <b>{isFr ? 'Lieu': 'Location'}</b>: Saint-Tropez</p>

      {contract && contract?.type?.value === 'in' && contract?.sign && contract?.sign?.bURL64 && (
        <img style={ { width: 100, backgroundColor:'white', padding:5}} src={contract?.sign?.bURL64} />
      )}

        <p style={{marginBottom:200}}>Réf: {id}</p>
      </div>)}
 
      {contract?.type?.value === 'in' && contract?.sign === undefined && (
  <>
   {!l && contract && prep ? (<div class="cookie-consent-banner">
        <div class="cookie-consent-banner__inner">
          <div class="cookie-consent-banner__copy">
            <div class="cookie-consent-banner__header">{isFr ? 'Signature du contrat': 'Contract signature'}</div>
            {!lsms && (<div class="cookie-consent-banner__description">
            {isFr ? 'Signature électronique avancée sécurisé via sms' : 'Secure advanced electronic signature via sms'}.<br/>
            {isFr ? 'Vous allez recevoir un sms avec un code de sécurité pour valider votre identité et signer numériquement votre état des lieux en ligne. Veuillez lire attentivement le contrat': 'You will receive an SMS with a security code to validate your identity and digitally sign your online inventory of fixtures. Please read the contract carefully'}.
            </div> )}
          </div>

          <div class="cookie-consent-banner__actions">
            {lsms ? (
              <>
               <Form noValidate validated={validated} onSubmit={handleSubmit}>
               <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="sms_code">
                        <Form.Label>CODE SMS</Form.Label>
                        <Form.Control  
                            type="text"
                            required
                            value={formd.sms_code}
                            name="sms_code"
                            onChange={handleChange}
                            placeholder="678767" 
                        /> 
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="signature" >
                          <Form.Label>{isFr ? 'Signature' : 'Sign'}</Form.Label>
                          <SignatureCanvas ref={(ref) => { sigCanvas = ref }} enColor='green' canvasProps={{width: 460, height: 200, className: 'sigCanvas'  }} />
                        </Form.Group> 
                        </Row>
                        <Button type="submit" class="btn btn-success" disabled={l}>{l ? 'Chargement' : isFr ?'Je signe ': 'I sign'}</Button>
                        
                     
                </Form>
              </>
            ) :
            (
              <a href="#" onClick={sendSMS} class="cookie-consent-banner__cta">
                {stateLsms ? 'Chargement ...' : 'OK'}
              </a>
            )} 
             
          </div>
        </div>
      </div>) : (
        <div class="cookie-consent-banner">
          <div class="cookie-consent-banner__inner" style={{textAlign:'end'}}>
          <a  onClick={() => {setPrep(true)}} class="cookie-consent-banner__cta">
               {isFr ? 'Signer (Signature automatique sous 24h après lecture.)': 'Signed (Automatic signature within 24h after reading.)'}
              </a>
              </div>
        </div>
      )}
  </>
)}

     


    </>
  );
};

export default StateLieu;
